import { GET_PROMOTIONAL_SIGNUP_CONTENT_REQUEST } from '../actionTypes/PromotionalSignUpActionTypes';

export const getPromotionalSignUpContentAction = () => ({
    type: GET_PROMOTIONAL_SIGNUP_CONTENT_REQUEST,
    payload: {},
});

export default {
    getPromotionalSignUpContentAction,
};
